var text_field_default = {
  "root": "I0aKZ",
  "text": "_2sy-w",
  "input": "HLvCQ",
  "small": "hwtOv",
  "medium": "_7b67U",
  "large": "wxslC",
  "webview": "kOCFj",
  "endAdornment": "_51oIC",
  "shown": "Ud-lB",
  "value": "kzWz0",
  "spinner": "kJXB8",
  "spin": "eqgZy"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
